import React, { useState, useEffect } from 'react';
import { Button, Modal, Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Share } from "@material-ui/icons";
import * as Yup from "yup";
import { makeStyles } from "@material-ui/core/styles";
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import Paper from '@material-ui/core/Paper';
import { Formik, Field, Form } from "formik";
import moment from "moment-timezone";
import { connect } from "react-redux";
import { getSubUsers } from "../../Actions/profileActions";
import { addSharedCreatives } from "../../Actions/creativeActions";

let timeZones = moment.tz.names();
let offsetTmz=[];


for(let i in timeZones){
  offsetTmz.push(`(GMT${moment.tz(timeZones[i]).format('Z')}) ${timeZones[i]}`);
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: "none"
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

const ShareCreativeModal = (props) => {

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { getSubUsers, addSharedCreatives, subUsers, creatives } = props;

  const [formData, setFormData] = useState({
    creatives : [],
    clients : []
  });

  // console.log("Data :", formData);

  const handleOpen = () => {
    setOpen(true);

  }

  const handleClose = () => {
    setOpen(false);

  };

  useEffect(()=>{
    getSubUsers();
  }, []);


  return (
    <React.Fragment>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpen}
        startIcon={<Share />}
        className={classes.margin}
      >
        Share Creatives
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 100,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h2>Share Campaigns</h2>
            <div>

              
            </div>
            <Paper style={{width: "50vw", padding: "1rem" }}>
              <Formik
                enableReinitialize={true}
                initialValues={formData}

                validationSchema={ Yup.object().shape({
                  creatives : Yup.array().required("Please Select the creatives"),
                  clients : Yup.array().required("Please select client")
                })}

                onSubmit={async (data, props) => {
                  
                  // console.log(data);
                  // props.resetForm();
                  addSharedCreatives(data, () => {
                    props.resetForm();
                    handleClose();
                  });
                }}

              >
                {({ values, handleSubmit, errors, touched, setFieldValue }) => (
                  <Form onSubmit={handleSubmit}>
                    <Grid container spacing={4}>

                      <Grid item md={6}>
                      
                        <Autocomplete
                          id="creative"
                          value={values.campaign}
                          options={[...creatives]}
                          size="small"
                          multiple
                          onChange={(e, value) => {
                            // console.log(value);
                            setFormData({
                              ...formData,
                              creatives : value
                            })
                            setFieldValue('creatives', value);
                          }}
                          getOptionLabel={(option) => option.original_name}
                          getOptionSelected={(option, value) => option.original_name === value.original_name}
                          // style={{ width: 300 }}
                          renderInput={(params) => (
                            <TextField 
                            
                              {...params} 
                              name="creatives" 
                              label="Creative Name"

                              error={errors.creatives && touched.creatives }
                              helperText={touched.creatives && errors.creatives}
                              
                            />
                          )}
                          // loading={true}
                        />
                      </Grid>

                      <Grid item md={6}>

                        <Autocomplete
                          id="client"
                          value={values.client}
                          options={[...subUsers]}
                          size="small"
                          multiple
                          onChange={(e, value) => {
                            setFormData({
                              ...formData,
                              clients : value
                            })
                            setFieldValue('clients', value);
                          }}
                          fullWidth
                          getOptionLabel={(option) => `${option.name} <${option.email}>`}
                          getOptionSelected={(option, value) => option.email === value.email}
                          // style={{ width: 300 }}
                          renderInput={(params) => (
                            <TextField 
                            
                              {...params} 
                              name="clients" 
                              label="Client Name" 
                              error={errors.clients && touched.clients }
                              helperText={touched.clients && errors.clients}
                            
                            />
                          )}
                          // loading={true}
                          
                        />
                      </Grid>

                      <Grid item md={6}>
                        <Button type="submit" variant="contained" color="primary"> Submit </Button>
                      </Grid>

                    </Grid>

                  </Form>
                )}
              </Formik>

            </Paper>
          </div>
        </Fade>
      </Modal>

    </React.Fragment>
  )
}

const mapStateToProps = (state) => {

  // console.log("Users :", state.profile);
  return {
    subUsers : state.profile.subUsers,
    creatives : state.creatives
  };
}

export default connect(mapStateToProps, {getSubUsers, addSharedCreatives})(ShareCreativeModal);
